const SERVER_COLORS = [
    "hsl(205, 70%, 41%)",
    "hsl(167, 72%, 49%)",
    "hsl(120, 57%, 40%)",
    "hsl(360, 69%, 50%)",
    "hsl(271, 39%, 57%)",
    "hsl(10, 30%, 42%)",
    "hsl(318, 66%, 68%)",
    "hsl(0, 0%, 50%)",
    "hsl(28, 100%, 53%)",
    "hsl(300, 100%, 50%)",
    "hsl(189, 100%, 50%)",
    "hsl(120, 100%, 50%)",
]

export { SERVER_COLORS }
